import { render, staticRenderFns } from "./CreateUsers.vue?vue&type=template&id=68139502&"
import script from "./CreateUsers.vue?vue&type=script&lang=js&"
export * from "./CreateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports